/* unplugin-vue-components disabled */import script from "./mg-search-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./mg-search-bar.vue?vue&type=script&setup=true&lang=js"

import "./mg-search-bar.vue?vue&type=style&index=0&id=dac40490&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dac40490"]])

export default __exports__